/**
 * Calculate the read time of a post and display it.
 */

import React from "react"

const ReadTime = ({content}) => {
  if (!content) {
    return null
  }

  const wordsPerMinute = 200
  const words = content.split(" ").length
  const minutes = words / wordsPerMinute

  return (
    <span className="read-time">
      {Math.ceil(minutes)} min read
    </span>
  )
}

export default ReadTime
